import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { routes } from "consts";
import { HeaderWithBreadcrumbs } from "components/molecules/HeaderWithBreadcrumbs/HeaderWithBreadbrumbs";
import { PageMain } from "components/molecules";
import { PaziaLoader } from "components/atoms";
import { PaziaTabs } from "components/atoms/PaziaTabs/PaziaTabs";
import { useKsefIntegration } from "api/ksef";
import { SubmissionsTab } from "./tabs/SubmissionsTab";
import { LogsTab } from "./tabs/LogsTab";

type TabName = "submissions" | "logs";

export const KSeFViewPage = (): JSX.Element => {
  const { ksefId } = useParams();
  const id = Number(ksefId);
  const { isLoading, integration } = useKsefIntegration(id);
  const [activeTab, setActiveTab] = useState<TabName>("submissions");

  return (
    <PageMain>
      <HeaderWithBreadcrumbs
        breadcrumbs={[
          { title: "KSeF", path: routes.KSEF },
          { title: integration?.name ?? "Integracja" },
        ]}
        headerText={integration?.name ?? "Integracja KSeF"}
      />
      {isLoading && <PaziaLoader position="center" />}
      {integration && (
        <div className="flex items-center gap-3 mb-4">
          <span
            className={`rounded-full px-2 py-0.5 text-xs font-medium ${
              integration.environment === 1
                ? "bg-yellow-100 text-yellow-700"
                : "bg-green-100 text-green-700"
            }`}
          >
            {integration.environment === 1 ? "Test" : "Produkcja"}
          </span>
          <span
            className={`rounded-full px-2 py-0.5 text-xs font-medium ${
              integration.isEnabled ? "bg-green-100 text-green-700" : "bg-red-100 text-red-600"
            }`}
          >
            {integration.isEnabled ? "Aktywna" : "Nieaktywna"}
          </span>
          <span className="text-sm text-slate-500">NIP: {integration.nip}</span>
        </div>
      )}

      <PaziaTabs
        className="mb-6"
        tabs={[
          {
            name: "Zgłoszenia",
            active: activeTab === "submissions",
            onClick: () => setActiveTab("submissions"),
          },
          {
            name: "Logi",
            active: activeTab === "logs",
            onClick: () => setActiveTab("logs"),
          },
        ]}
      />

      {activeTab === "submissions" && <SubmissionsTab integrationId={id} />}
      {activeTab === "logs" && <LogsTab integrationId={id} />}
    </PageMain>
  );
};
